import { FilterType } from "src/api/types";
import { monthsMap } from "src/constants/monthsMap";
import {
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  PHONE_NUMBER,
  STATUS,
  LANGUAGE,
  STATE,
  REFILL,
  TEST_PATIENTS,
} from "src/constants/searchParams";
import { statesMap } from "src/constants/usStates";

export const filters: FilterType[] = [
  {
    name: FIRST_NAME,
    placeholder: "First name",
    type: "text",
  },
  {
    name: LAST_NAME,
    placeholder: "Last name",
    type: "text",
  },
  {
    name: EMAIL,
    placeholder: "Email",
    type: "text",
  },
  {
    name: PHONE_NUMBER,
    placeholder: "Phone number",
    type: "text",
  },
  {
    name: STATUS,
    placeholder: "Status",
    type: "select",
    values: [
      "Active",
      "Canceled",
      "Lead",
      "Onboarded",
      "Suspended",
      "Registered",
      "Paused",
      "Banned",
    ],
  },
  {
    name: LANGUAGE,
    placeholder: "Language",
    type: "select",
    values: ["en", "es", "pt"],
  },
  {
    name: STATE,
    placeholder: "State",
    type: "autocomplete",
    values: Object.values(statesMap),
  },
  {
    name: REFILL,
    placeholder: "Refill month",
    type: "autocomplete",
    values: Object.values(monthsMap),
  },
  {
    name: TEST_PATIENTS,
    type: "checkbox",
    label: "Filter test patients",
  },
];
